import { type AccentHue, colorize } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import { For, type JSX, Show } from "solid-js"
import { Icon } from "../components/icon"
import { pillRecipe, pillsClass } from "./pills.css"

export type Pill = {
  icon?: IconName
  rounded?: boolean
  label: string
  hue: AccentHue
}

type PillsProps = {
  pills: Pill[]
  prepend?: JSX.Element
}

export function Pills(props: PillsProps) {
  return (
    <ul class={pillsClass}>
      {props.prepend}
      <For each={props.pills}>
        {pill => (
          <li class={pillRecipe({ hue: pill.hue, rounded: pill.rounded })}>
            <Show when={pill.icon}>
              {icon => (
                <Icon
                  color={colorize(pill.hue, "700")}
                  name={icon()}
                  title={pill.label}
                  size="12"
                />
              )}
            </Show>
            {pill.label}
          </li>
        )}
      </For>
    </ul>
  )
}
